import React from 'react';
import { footerData } from '../mockData';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo and Tagline */}
          <div className="col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_axicle-robotics/artifacts/urvypt34_Full%20Text%20Logo.svg" 
              alt="Axicle Robotics" 
              className="h-8 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm">
              {footerData.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {footerData.links.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href.replace('#', ''))}
                    className="text-gray-400 hover:text-red-600 transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-span-1">
            <h3 className="text-white font-semibold mb-4">Get in Touch</h3>
            <p className="text-gray-400 text-sm mb-2">
              Ready to revolutionize your fleet?
            </p>
            <a 
              href="mailto:steve@axicle.com" 
              className="text-red-600 hover:text-red-500 transition-colors duration-200 text-sm font-semibold"
            >
              steve@axicle.com
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} {footerData.company}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <button className="text-gray-500 hover:text-red-600 transition-colors duration-200 text-sm">
              Privacy Policy
            </button>
            <button className="text-gray-500 hover:text-red-600 transition-colors duration-200 text-sm">
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
